import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import EditSvg from 'images/v5/icons/edit-02.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Button from 'layout/atoms/Button/Button';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Loader from 'layout/atoms/Loader/Loader';
import { Cell, Row } from 'layout/atoms/TableGrid';
import EmptyState from 'layout/molecules/EmptyState/EmptyState';
import Grid from 'molecules/Grid/Grid';
import { openModal } from 'store/layoutSlice';
import { fetchElements, removeElement, selectElements, selectElementsErrors, selectElementsPageInfo, selectElementsRefetchFlags, selectElementsStatus, } from 'store/parameters/elementsSlice';
import ParametersTable from '../shared/ParametersTable';
function Elements({ toolbar }) {
    const dispatch = useDispatch();
    const { t } = useTranslation(['specification', 'common']);
    const elements = useSelector(selectElements);
    const pageInfo = useSelector(selectElementsPageInfo);
    const status = useSelector(selectElementsStatus);
    const errors = useSelector(selectElementsErrors);
    const refetchFlags = useSelector(selectElementsRefetchFlags);
    const fetchMore = () => {
        if (pageInfo.hasNextPage && status.fetch !== 'loading') {
            dispatch(fetchElements());
        }
    };
    useEffect(() => {
        if (status.fetch === 'idle' || refetchFlags.fetch) {
            dispatch(fetchElements());
        }
    }, [dispatch, status.fetch, refetchFlags.fetch]);
    const handleDelete = (elementId) => {
        dispatch(removeElement(elementId));
    };
    if (status.fetch === 'loading' || status.fetch === 'idle') {
        return React.createElement(Loader, null);
    }
    if (status.fetch === 'failed') {
        return React.createElement("div", null, errors.fetch);
    }
    return (React.createElement(Grid, { gap: 24 },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } }, toolbar),
        elements.length === 0 ? (React.createElement(EmptyState, null)) : (React.createElement(ParametersTable, { columns: [
                ['320px', '1fr'],
                ['72px', 'auto'],
            ], headers: [{ content: t('common:name') }, { content: null }], dataLength: elements.length, hasMore: pageInfo.hasNextPage, fetchMore: fetchMore }, elements.map((element) => (React.createElement(Row, { key: element.id },
            React.createElement(Cell, null, element.name),
            React.createElement(Cell, null,
                React.createElement(Dropdown, null,
                    React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(EditSvg, null), onClick: () => dispatch(openModal({ name: 'elementEditor', id: element.id })) }, t('common:edit')),
                    React.createElement(Button, { align: "left", theme: "ghost", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: () => handleDelete(element.id) }, t('common:delete')))))))))));
}
export default memo(Elements);
